import React from "react";
import { Squares2X2Icon } from "@heroicons/react/24/outline";
import ListItemTab from "./ListItemTab";

const DashboardItem = ({onClick, active}) => {
  return (
    <ListItemTab
      icon={Squares2X2Icon}
      label="Dashboard"
      onClick={onClick}
      active={active}
    />
  );
};

export default DashboardItem;
